export default [
  {
    // :id opcional a propósito — el detalle es un drawer que se abre SOBRE el
    // tablero/tabla (no una página aparte), para que el deep-link de las
    // notificaciones de Slack (/ordenes-trabajo/{id}) y el botón "atrás" del
    // navegador abran/cierren el drawer sin perder el listado de fondo.
    path: '/ordenes-trabajo/:id?',
    name: 'ordenes-trabajo',
    component: () => import(/* webpackChunkName: "ordenes-trabajo" */
      '@/pages/ordenes-trabajo/OrdenesTrabajoPage.vue'),
    props: true,
    meta: { requiresAuth: true }
  }
]
